module.exports = __webpack_public_path__ + "img/Protect.954676ba.png";